import styled from '@emotion/styled';
import { Stack } from '@ui-components/neo.tax';

import { Menu } from '@neo.tax/shared/organisms';
import { ZIndex } from '@neo.tax/shared/utils';

export const PayrollQreLayoutStyled = styled(Stack)({
  width: '100%',
  height: '100%',
});

export const StyledSetRdPercentageMenu = styled(Menu)({
  zIndex: ZIndex.MODAL,
  width: 'auto',
});
